import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import isFunction from 'lodash-es/isFunction';
import { SidenavItem } from 'src/app/models/menu-item';
import { SidenavCategory } from "src/app/models/SidenavCategory";
import { SidenavService } from 'src/app/services/sidenav.service';
import { MenuRevolution } from 'src/app/models/menu/menu.model';

@Component({
  selector: 'app-sidenav-item-revolution',
  templateUrl: './sidenav-item-revolution.component.html',
  styleUrls: ['./sidenav-item-revolution.component.scss'],
  animations: [
    trigger('dropdownOpen', [
        state('false', style({
            height: 0
        })),
        state('true', style({
            height: '*'
        })),
        transition('false <=> true', animate('300ms cubic-bezier(.35, 0, .25, 1)'))
    ])
  ],
  standalone: false
})
export class SidenavItemRevolutionComponent implements OnInit {

  @Input('level') level: number = 0;
  @Input('item') item: MenuRevolution | undefined;

  isCollapsed$ = this.sidenavService.collapsed$;
  dropdownOpen$: Observable<boolean>;

  constructor(private readonly sidenavService: SidenavService, private readonly router: Router) {
    this.dropdownOpen$ = this.sidenavService.currentlyOpenRevolution$.pipe(
      map((currentlyOpen: any) => (this.item instanceof MenuRevolution) && this.item?.subMenuItems && this.item?.subMenuItems.length > 0 && currentlyOpen.indexOf(this.item) > -1)
    ) ;
  }

  get levelClass() {
    return `level-${this.level}`;
  }

  ngOnInit() {

    if (this.item && this.item instanceof MenuRevolution){
      if (this.item.subMenuItems && this.item.subMenuItems.length > 0) {
        const auxItem = this.item;
        for (let auxitem of this.item.subMenuItems){
          if (auxitem.metadata.route == this.router.url) {
            this.sidenavService.toggleItemOpenRevolution(auxItem);
            break;
          }
        }

      }
    }
  }

  isFunction(routeOrFunction: string[] | Function) {
    return isFunction(routeOrFunction);
  }

  handleClick() {
    if (this.item) {
      if (this.item.parent == null){
        if (this.item.subMenuItems && this.item.subMenuItems.length > 0) {
          this.sidenavService.toggleItemOpenRevolution(this.item);
        } else if (this.item.metadata.route && typeof this.item.metadata.route === 'string') {
          this.router.navigate([this.item.metadata.route]);
        }  else {
          throw Error('Could not determine what to do, Sidenav-Item has no routeOrFunction set AND does not contain any subItems');
        }
      } else if (this.item.parent){
        if (this.item.metadata.route && typeof this.item.metadata.route === 'string') {
          this.router.navigate([this.item.metadata.route]);
        } else {
          throw Error('Could not determine what to do, Sidenav-Item has no routeOrFunction set AND does not contain any subItems');
        }
      }
    }

  }

  getTextIcon(item: MenuRevolution | undefined) {
    let result = '';
    if (item?.name) {
      const name = item.name.split(' ');
      if (name.length > 0) {
        result += name[0].charAt(0).toUpperCase();
      }
      if (name.length > 1) {
        result += name[1].charAt(0).toLowerCase();
      }
      if (name.length === 1) {
        result += name[0].charAt(1).toLowerCase();
      }
    }
    return result;
  }

  hasSubItems(item: MenuRevolution | undefined){
    if (item){
      if (item.subMenuItems) {
        return item.subMenuItems.length > 0
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isCategory() {
    return !!((this.item?.parent == null) && (this.item?.isActive));
  }

  isItem() {
    return !!((this.item?.parent != null) && (this.item.isActive));
  }

  returnValueClass() {
    return this.item?.metadata.customClass;
  }

  returnType() {
    return this.item?.metadata.type;
  }


  returnValue(label: string):any {
    switch (label) {
        case 'name':
            return this.item?.name;
        case 'icon':
            return this.item?.metadata.icon;
        case 'position':
            return '' + this.item?.position;
        case 'type':
            return this.item?.metadata.type;
        case 'customClass':
            return this.item?.metadata.customClass;
        case 'badge':
            return this.item?.metadata.badge;
        case 'badgeColor':
            return this.item?.metadata.badgeColor;
        case 'route':
          return this.item?.metadata.route;
        case 'items':
          return this.item?.subMenuItems;
        default:
            break;
    }

  }

  returnValueActive(label: string) {
    return this.router.url !== this.item?.metadata.route;
  }

  

  returnValueCategory(label: string) {
    return (this.item instanceof SidenavCategory) ? this.item.getValue(label) : null;
  }

  returnValueItem(label: string) {
    return (this.item instanceof SidenavItem) ? this.item.getValue(label) : null;
  }
  
  returnActiveCategory(label: string) {
    return (this.item instanceof SidenavCategory) ? (this.router.url !== this.item.getValue(label)) : false;
  }

  returnActiveItem(label: string) {
    return (this.item instanceof SidenavItem) ? (this.router.url !== this.item.getValue(label)) : false;
  }

}
